import { Injectable } from '@angular/core';
import {ApiUrlService} from "../services/api-url.service";

@Injectable({
  providedIn: 'root',
})
export class ApplicationConfigService {
  private endpointPrefix = '';
  private microfrontend = false;

  constructor(private apiUrlService: ApiUrlService) {}

  setEndpointPrefix(endpointPrefix: string): void {
    this.endpointPrefix = endpointPrefix;
  }

  setMicrofrontend(microfrontend = true): void {
    this.microfrontend = microfrontend;
  }

  isMicrofrontend(): boolean {
    return this.microfrontend;
  }

  getEndpointFor(api: string, microservice?: string): string {
    this.endpointPrefix = this.apiUrlService.getApiUrl();
    if (microservice) {
      return `${this.endpointPrefix}/services/${microservice}/${api}`;
    }
    return `${this.endpointPrefix}${api}`;
  }
}
